<ui-icon uiType="outline:close" class="fs-24px" uiTooltipTitle="Test Title"></ui-icon>
